import { Button, Modal } from "antd";
import styled from "styled-components";

export const MirroredImgContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  width: 100%;

  height: 30.5%;
  gap: 3px;
  top: 10%;
  background-color: transparent;
`;

export const ImageOverlay = styled.div`
  background-color: white;
  width: 50%;
  height: 100%;
  align-items: center;
  justify-content: center;
  display: flex;
  img {
    width: 100%;
    object-fit: contain;
  }
`;

export const ModalOverlay = styled(Modal)`
  width: 30% !important;
  height: auto !important;
  .ant-modal-content {
    align-items: center;
    justify-content: center;
    border-radius: 15px;
  }
`;

export const ActionButton = styled(Button)`
  && {
    margin-inline: 10px;
    min-width: 110px;
    height: 34px;
    border-radius: 5px;
    gap: 8px;

    display: inline-flex;
    align-items: center;
    justify-content: center;

    background-color: ${(props) =>
      props.print ? "#44a049" : "rgba(254, 202, 202, 1)"} !important;

    border-color: ${(props) =>
      props.print ? "#44a049" : "rgba(254, 202, 202, 1)"} !important;

    color: ${(props) =>
      props.print ? "#ffffff" : "rgba(153, 27, 27, 1)"} !important;

    font-family: "Open Sans";
    font-weight: 700;
    font-size: 14px;
    text-transform: uppercase;

    box-shadow: none;
  }

  &&:hover {
    background-color: ${(props) =>
      props.$print ? "#44a049" : "rgba(254, 202, 202, 1)"};

    border-color: ${(props) =>
      props.$print ? "#44a049" : "rgba(254, 202, 202, 1)"};

    color: ${(props) => (props.$print ? "#ffffff" : "rgba(153, 27, 27, 1)")};

    opacity: 0.8;
  }

  &&:focus,
  &&:active {
    background-color: ${(props) =>
      props.$print ? "#44a049" : "rgba(254, 202, 202, 1)"};

    border-color: ${(props) =>
      props.$print ? "#44a049" : "rgba(254, 202, 202, 1)"};

    color: ${(props) => (props.$print ? "#ffffff" : "rgba(153, 27, 27, 1)")};
  }

  &&.ant-btn-loading,
  &&.ant-btn-disabled,
  &&.ant-btn[disabled] {
    background-color: ${(props) =>
      props.$print ? "#44a049" : "rgba(254, 202, 202, 1)"};

    border-color: ${(props) =>
      props.$print ? "#44a049" : "rgba(254, 202, 202, 1)"};

    color: ${(props) => (props.$print ? "#ffffff" : "rgba(153, 27, 27, 1)")};

    opacity: 0.6;
    cursor: not-allowed;
  }
`;
